import { connect } from 'react-redux';
import {
  setLocale,
  fetchTranslationsRequest,
  toggleDefinitionMode,
} from 'language-provider/containers/language-provider-actions';
import LocaleToggle from '../components/locale-toggle';

const mapStateToProps = state => ({
  locale: state.languageProvider.locale,
  supportedLanguages: state.languageProvider.supportedLanguages,
});

const mapDispatchToProps = {
  setLocale,
  fetchTranslations: fetchTranslationsRequest,
  toggleDefinitionMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocaleToggle);
